'use client';

import React, { useEffect } from 'react';

import {
  PageTilesContentQuery,
  TileFragmentFragment,
} from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { componentByTypename } from '@/ui/utils/componentByTypename';
import { ClassicPdpProductProvider } from '@/ui/providers/classic-pdp-product-provider';
import { useSubnavData } from '@/ui/providers/subnavDataProvider';
import { readClassicPdpProducts } from '@/ui/components/tiles/classic-product-detail/classic-pdp-entry';
import TilesArrayRenderer from './tiles-array-renderer';

export interface PageTilesRendererProps {
  data: PageTilesContentQuery['catalogue'];
}

export default function PageTilesRenderer({ data }: Readonly<PageTilesRendererProps>) {
  const pageContent = componentByTypename(data, 'Document');
  const subnavItem = componentByTypename(pageContent?.subnav?.content, 'ItemRelationsContent')
    ?.items?.[0];
  const subnavData = componentByTypename(subnavItem, 'Document');
  const { setSubnavData } = useSubnavData();

  const tiles = componentByTypename(pageContent?.tiles?.content, 'ItemRelationsContent')?.items;

  useEffect(() => {
    setSubnavData(subnavData);
  }, [subnavData, setSubnavData]);

  if (!tiles || tiles.length === 0) {
    return null;
  }

  return (
    // Classic product detail tiles render a full product, which the server
    // resolved and attached to this payload.
    <ClassicPdpProductProvider entries={readClassicPdpProducts(data)}>
      <TilesArrayRenderer tiles={tiles as TileFragmentFragment[]} />
    </ClassicPdpProductProvider>
  );
}
